// Reusable validation you can use on both Register and Login

export const validateRegister = (fields: {
  fullName: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
}) => {
  const errors: Record<string, string> = {};

  if (!fields.fullName.trim())
    errors.fullName = "Full name is required.";

  if (!fields.email)
    errors.email = "Email is required.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email))
    errors.email = "Please enter a valid email.";

  if (!fields.phone)
    errors.phone = "Phone number is required.";
  else if (!/^(\+27|0)[6-8][0-9]{8}$/.test(fields.phone))
    errors.phone = "Please enter a valid SA phone number.";

  if (!fields.password)
    errors.password = "Password is required.";
  else if (fields.password.length < 8)
    errors.password = "Password must be at least 8 characters.";

  if (fields.password !== fields.confirmPassword)
    errors.confirmPassword = "Passwords do not match.";

  return errors;
};

export const validateLogin = (fields: {
  email: string;
  password: string;
}) => {
  const errors: Record<string, string> = {};

  if (!fields.email)
    errors.email = "Email is required.";
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email))
    errors.email = "Please enter a valid email.";

  if (!fields.password)
    errors.password = "Password is required.";

  return errors;
};